import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { lastValueFrom, Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { MelissaAddressResponseDto } from "../models/shared/mellssaAddressResponseDto";
import { ZipCodeDetails } from "../models/shared/zipCodeDetails";
import { GenericResponseDto } from "../models/generic-response.dto";
import { City } from "../models/shared/cityList";
import { MelissaAddressFormatResponseDto } from "../models/shared/melissaAddressFromatResponseDto";

@Injectable({
  providedIn: "root",
})
export class AddressService {
  private commonBaseURL = environment.baseUrl + "/Common";
  private melissaBaseURL = environment.baseUrl + "/Melissa";
  private locationBaseURL = environment.baseUrl + "/Location";
  constructor(private _http: HttpClient) {}

  getMelissaData(
    street: string,
    country: string
  ): Promise<MelissaAddressResponseDto[]> {
    return lastValueFrom(
      this._http.get<MelissaAddressResponseDto[]>(
        `${this.melissaBaseURL}/GetMelisaAPI?address=${street}&country=${country}`
      )
    );
  }

  getMelissaGlobalData(
    address1: string,
    country: string,
    city: string,
    state: string,
    address2: string,
    address3: string,
    postalcode: string
  ): Promise<MelissaAddressResponseDto[]> {
    return lastValueFrom(
      this._http.get<MelissaAddressResponseDto[]>(
        `${this.melissaBaseURL}/MelissaAddressGlobal?address1=${address1}&country=${country}&
        address2=${address2}&locality=${city}&
        address3=${address3}&administrativearea=${state}&
        postalcode=${postalcode}`
      )
    );
  }

  getPostalCodeByZipCode(
    zipCode: string
  ): Observable<GenericResponseDto<ZipCodeDetails>> {
    return this._http.get<GenericResponseDto<ZipCodeDetails>>(
      `${this.commonBaseURL}/GetPostalCodeByZipCode?zipCode=${zipCode}`
    );
  }

  getCityList(
    stateid: string,
    countryid: string
  ): Observable<GenericResponseDto<City[]>> {
    return this._http.get<GenericResponseDto<City[]>>(
      this.locationBaseURL +
        `/GetAllCitiesByCountryIdAndState?countryId=${countryid}&stateId=${stateid}`
    );
  }

  checkAddressValidation(
    address: string,
    country: string
  ): Observable<MelissaAddressFormatResponseDto[]> {
    return this._http.post<MelissaAddressFormatResponseDto[]>(
      this.melissaBaseURL + `/MelissaAddressFormat`,
      {
        country,
        address,
      }
    );
  }

  checkAddressValidationForNonUs(
    address: string,
    country: string
  ): Observable<MelissaAddressFormatResponseDto[]> {
    return this._http.post<MelissaAddressFormatResponseDto[]>(
      this.melissaBaseURL + `/MelissaAddressFormat`,
      {
        country,
        address,
      }
    );
  }
}
